import React from "react";

declare global {
  interface Window {
    __PRERENDER_DATA__?: Record<string, unknown>;
  }
}

function serialize(value: unknown): string {
  try {
    return JSON.stringify(value)?.replace(/</g, "\\u003c").replace(/>/g, "\\u003e");
  } catch {
    return "null";
  }
}

export function readPrerenderJson<T>(id: string): T | null {
  if (typeof window !== "undefined") {
    const existing = window.__PRERENDER_DATA__?.[id];
    if (existing) {
      return existing as T;
    }
  }

  if (typeof document === "undefined") return null;
  const el = document.getElementById(id);
  if (!el) return null;

  try {
    const text = el.textContent ?? el.innerHTML ?? "";
    if (!text) return null;
    const parsed = JSON.parse(text) as T;
    if (typeof window !== "undefined") {
      window.__PRERENDER_DATA__ = window.__PRERENDER_DATA__ || {};
      window.__PRERENDER_DATA__[id] = parsed;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function PrerenderData({ id, value }: { id: string; value: unknown }) {
  const payload = serialize(value);
  const assignScript = `window.__PRERENDER_DATA__ = window.__PRERENDER_DATA__ || {}; window.__PRERENDER_DATA__[${JSON.stringify(
    id,
  )}] = ${payload};`;

  return (
    <>
      <script id={id} type="application/json" dangerouslySetInnerHTML={{ __html: payload }} />
      <script dangerouslySetInnerHTML={{ __html: assignScript }} />
    </>
  );
}
